import {CONFIG} from 'config/config';

export function setCookie(cname, cvalue, exdays, cpath = '/', cdomain) {
    const cookieData = [`${cname}=${cvalue}`];
    const domain = cdomain || CONFIG.DEFAULT_COOKIE_DOMAIN || `.${location.hostname.replace('www.','')}`;

    if (exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        cookieData.push("expires="+ d.toUTCString());
    }

    cookieData.push(`domain=${domain}`);
    cookieData.push(`path=${cpath}`);

    document.cookie = cookieData.join(';').replace(/;$/, '');
}

export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function removeCookie(name) {
    if (!getCookie(name)) {
        return;
    }

    setCookie(name, null, 'Thu, 01 Jan 1970 00:00:01 GMT');
}
